import ResourcesListingsContainer from './resources_listings_container';

const ResourcesListings = ResourcesListingsContainer;
export default ResourcesListings;
